import { createState } from '@helpers/createState'
import { combineReducers } from 'redux'

import * as TYPES from '../constants/actionTypes'
import * as STATE from '../constants/state'

const reducer = combineReducers({
  [STATE.HR_APPLICATION]: createState(TYPES.HR_APPLICATION),
  [STATE.HR_APPLICATION_LIST]: createState(TYPES.HR_APPLICATION_LIST),
  [STATE.HR_APPLICATION_ALL]: createState(TYPES.HR_APPLICATION_ALL),
  [STATE.HR_APPLICATION_TYPES]: createState(TYPES.HR_APPLICATION_TYPES),
  [STATE.HR_APPLICATION_STATUS]: createState(TYPES.HR_APPLICATION_STATUS),
  [STATE.HR_APPLICATION_FIELD_BATCH]: createState(TYPES.HR_APPLICATION_FIELD_BATCH),
  [STATE.HR_APPLICATION_CATEGORY]: createState(TYPES.HR_APPLICATION_CATEGORY),
  [STATE.HR_APPLICATION_CATEGORY_LIST]: createState(TYPES.HR_APPLICATION_CATEGORY_LIST),
  [STATE.HR_APPLICATION_CATEGORY_ALL]: createState(TYPES.HR_APPLICATION_CATEGORY_ALL),
  [STATE.HR_APPLICATION_REQUEST_ALL]: createState(TYPES.HR_APPLICATION_REQUEST_ALL),
  [STATE.HR_APPLICATION_REQUEST_EDIT]: createState(TYPES.HR_APPLICATION_REQUEST_EDIT),
  [STATE.HR_APPLICATION_REQUEST_UPDATE]: createState(TYPES.HR_APPLICATION_REQUEST_UPDATE),
})

export const HR = STATE.GLOBAL_STATE

export default reducer
